import Http from "./http";

export const updateGroupProductFeatureAPI = (data) => {
    return Http.post("admin/group/updateGroupProductFeature", data);
};
